// Eigenbau: Fehlerzeile für API-Gründe inkl. Versionskonflikt-Neuladen
// (mindestens 20 Zeichen Begründung im Kopf).

import { Button } from "@/components/Button";
import type { Meldung } from "@/lib/meldung";

export function Fehlerzeile({
  meldung,
  onNeuLaden,
  onErneut,
}: {
  meldung: Meldung;
  onNeuLaden?: () => void;
  onErneut?: () => void;
}) {
  return (
    <div
      className="flex flex-col gap-2 rounded-md border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-900 dark:border-red-900/50 dark:bg-red-950/40 dark:text-red-200 sm:flex-row sm:items-center sm:justify-between"
      role="alert"
      data-testid="fehlerzeile"
      data-art={meldung.art}
    >
      <p>{meldung.text}</p>
      <div className="flex gap-2">
        {meldung.neuLadenAnbieten && onNeuLaden ? (
          <Button variant="secondary" onClick={onNeuLaden}>
            Neu laden
          </Button>
        ) : null}
        {meldung.erneutVersuchen && onErneut ? (
          <Button variant="secondary" onClick={onErneut}>
            Erneut versuchen
          </Button>
        ) : null}
      </div>
    </div>
  );
}
